import React from 'react';

// Fundle wordmark — matches the fundle-brain-rebuild reference:
// "fundle" in deep navy + "." in vibrant blue + "ai" in deep navy.
export const FundleLogo = ({ className = '', dark = false }) => (
  <span
    className={`inline-flex items-baseline font-extrabold text-[22px] tracking-tight leading-none ${className}`}
    data-testid="fundle-logo"
  >
    <span className={dark ? 'text-white' : 'text-[#14223D]'}>fundle</span>
    <span className="text-[#2563EB]">.</span>
    <span className={dark ? 'text-white' : 'text-[#14223D]'}>ai</span>
  </span>
);

export default FundleLogo;
